import { render, staticRenderFns } from "./Televendas.vue?vue&type=template&id=ba60b7fe"
import script from "./Televendas.vue?vue&type=script&lang=js"
export * from "./Televendas.vue?vue&type=script&lang=js"
import style0 from "./Televendas.vue?vue&type=style&index=0&id=ba60b7fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports